import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import { FaBoxes, FaPlus, FaShoppingCart } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import ModalProductos from '../ModalProductos';
import ProductoCard from './ProductoCard';
import { useToast } from 'context/providers/ToastProvider';

const ProductosContainer = (
    {
        productosAgregados,
        setProductosAgregados,
        ordenDetallesProductos
    }


) => {

    const { token, setToken } = useToken();
    const ejecutadoRef = useRef(false);
    const [cargando, setCargando] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const { showErrorToast } = useToast();

    useEffect(() => {
        if (!ejecutadoRef.current && ordenDetallesProductos && Array.isArray(ordenDetallesProductos) && ordenDetallesProductos.length > 0) {
            ordenDetallesProductos.forEach((producto) => {
                agregarProducto(producto);
            });
            ejecutadoRef.current = true; // Marcar como ejecutado
        }
    }, [ordenDetallesProductos]);


    /**
     * Obtiene un producto por su ID
     */
    const ObtenerProductoPorID = async (idProducto) => {
        setCargando(true)

        const response = await fetch("/api/Facturas/ObtenerProductoPorID", // Cambia el endpoint si es necesario
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(idProducto)
            })
            .catch((error) => {
                
                showErrorToast('Hubo un problema con la petición Fetch: ' + error);
                console.log('Hubo un problema con la petición Fetch:', error);
            });

        if (response?.ok) {
            setCargando(false);
            console.log("==== OBTENER PRODUCTO ====");
            const data = await response.json();
            console.log("dataRF: ", data);

            if (data.iResponseType === 1) {
                setMostrarModal(false)

                var ObjDetalles = JSON.parse(data.detalles);
                console.log("ObjDetallesPD:", ObjDetalles);

                agregarProducto(ObjDetalles.table2[0]);

            } else {
                
                showErrorToast(data.vMessage);
            }
        } else {
            setCargando(false);
            
            showErrorToast(response?.status + ' ' + response?.statusText);
            if (response?.status === 401) {
                setToken(null);
                location.href = "";
            }
        }
    };


    /**
     * Actualiza el campo de un producto específico usando idProducto
     */
    const actualizarCampo = (idUnica, campo, valor) => {
        setProductosAgregados((prevProductos) => {
            return prevProductos.map((producto) => {
                if (producto.idUnica !== idUnica) return producto; // No modificar otros productos

                // Actualizar el campo sin conversión
                const productoActualizado = {
                    ...producto,
                    [campo]: valor,
                };

                // Recalcular Importe, IVA y Total
                const importe = productoActualizado.dCantidad * productoActualizado.dPrecioUnitario;

                let iva = 0;
                if (productoActualizado.vTipoFactorIVA === "Tasa") {
                    // Corrección: Calcular IVA sobre el importe (precio base)
                    iva = importe * productoActualizado.dTasaCuotaIVA;
                } else if (productoActualizado.vTipoFactorIVA === "Cuota") {
                    iva = productoActualizado.dTasaCuotaIVA; // Cuota fija
                } // Si es "Exento", el IVA ya es 0

                const total = importe + iva;

                // Actualizar IVA y Total en el producto
                return { ...productoActualizado, dIVA: iva, dTotal: total, dImporte: importe };
            });
        });
    };

    /**
     * Agrega el producto a la tabla de productos
     */
    const agregarProducto = (producto) => {
        let dIVA = 0.0;
        const dPrecioUnitario = producto.dPrecioUnitario ?? 0.0;
        // Usar la cantidad del producto si existe, sino usar 1 como predeterminada
        const dCantidad = producto.dCantidad ?? 1;

        // Calcular el importe primero (precio unitario * cantidad)
        const dImporte = dPrecioUnitario * dCantidad;

        if (producto.vTipoFactorIVA === "Tasa") {
            // Calcular IVA sobre el importe (precio base * cantidad)
            dIVA = dImporte * (producto.dTasaCuotaIVA ?? 0.0);
        } else if (producto.vTipoFactorIVA === "Cuota") {
            // Si el tipo de factor es "Cuota", simplemente se suma el IVA como un monto fijo
            dIVA = producto.dTasaCuotaIVA ?? 0.0;
        }

        // Calcular el total sumando el IVA al importe
        const dTotal = dImporte + dIVA;

        const idUnica = uuidv4();

        const productoProcesado = {
            idUnica, // ID única para el manejo interno
            vCodigoBarras: producto.vCodigoBarras ?? "",
            vNombreProducto: producto.vNombreProducto ?? "Producto sin nombre",
            dPrecioUnitario: dPrecioUnitario,
            dTasaCuotaIVA: producto.dTasaCuotaIVA ?? 0.0,
            vTipoFactorIVA: producto.vTipoFactorIVA ?? "",
            dIVA: dIVA, // IVA calculado correctamente
            dImporte: dImporte, // Mantener ambos por compatibilidad
            vClaveUnidadSat: producto.vClaveUnidadSat ?? "",
            vCodigoProductoServicioSat: producto.vCodigoProductoServicioSat ?? "",
            dTotal: dTotal, // Total con IVA incluido
            dCantidad: dCantidad, // ✅ Usar la cantidad del producto o 1 por defecto
        };

        const file_jpg = productoProcesado.vImagenProducto_Base64
            ? base64ToFile(productoProcesado.vImagenProducto_Base64, productoProcesado.vImagenProducto_Name)
            : null;

        const imagenURL = file_jpg ? URL.createObjectURL(file_jpg) : null;

        // Agregar el producto a la lista
        setProductosAgregados((prevProductos) => [...prevProductos, { ...productoProcesado, imagenURL }]);
    };




    /**
     * Elimina producto de la tabla de productos agregados y lo regresa a disponibles
     */
    const eliminarProducto = (index) => {

        // Filtrar los productos agregados para eliminar el seleccionado
        const nuevosProductosAgregados = productosAgregados.filter((_, i) => i !== index);
        setProductosAgregados(nuevosProductosAgregados);

    };

    /**
     * Convertir Base64 a archivo
     */
    const base64ToFile = (base64String, fileName) => {
        // Validar si no hay imagen
        if (!base64String) return null;

        try {
            // Extraer el contenido Base64 de manera segura
            const base64Data = base64String?.split(',')[1] || base64String;

            // Validar formato Base64
            if (!/^[A-Za-z0-9+/=]*$/.test(base64Data)) {
                console.error('Formato Base64 inválido');
                return null;
            }

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const mimeType = base64String.split(';')[0]?.split(':')[1] || 'image/jpeg';

            return new File([new Blob([byteArray], { type: mimeType })], fileName, {
                type: mimeType,
                lastModified: Date.now()
            });

        } catch (error) {
            console.error('Error al convertir Base64 a File:', error);
            return null;
        }
    };



    // Calcular totales
    const calcularTotales = () => {
        const subtotal = productosAgregados.reduce((acc, prod) => acc + prod.dImporte, 0);
        const totalIVA = productosAgregados.reduce((acc, prod) => acc + prod.dIVA, 0);
        const total = productosAgregados.reduce((acc, prod) => acc + prod.dTotal, 0);
        return { subtotal, totalIVA, total };
    };

    const { subtotal, totalIVA, total } = calcularTotales();


    return (
        <>
            {cargando &&
                (
                    <h6>
                        <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                    </h6>
                )}
            <Row className="mt-4">
                <Col md={12}>
                    {/* Header profesional */}
                    <div
                        style={{
                            borderRadius: '8px 8px 0 0',
                            padding: '20px 25px',
                            border: '1px solid #e0e0e0',
                            borderBottom: '3px solid #009bdb',
                        }}
                    >
                        <Row className="align-items-center">
                            <Col xs={12} md={8}>
                                <div className="d-flex align-items-center gap-3">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '8px',
                                            background: '#009bdb',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <FaBoxes size={22} color="white" />
                                    </div>
                                    <div>
                                        <h5 className="mb-0" style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.1rem' }}>
                                            Productos de la Factura
                                        </h5>
                                        <p className="mb-0" style={{ color: '#7f8c8d', fontSize: '0.85rem' }}>
                                            {productosAgregados.length} {productosAgregados.length === 1 ? 'producto agregado' : 'productos agregados'}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="text-md-end mt-3 mt-md-0">
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => setMostrarModal(true)}
                                    style={{
                                        backgroundColor: '#009bdb',
                                        borderColor: '#009bdb',
                                        borderRadius: '6px',
                                        fontWeight: '500',
                                        padding: '8px 20px',
                                        border: 'none',
                                        transition: 'all 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#007a9e';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#009bdb';
                                    }}
                                >
                                    <FaPlus className="me-2" size={12} /> Agregar Producto
                                </Button>
                            </Col>
                        </Row>
                    </div>

                    {/* Contenedor de productos */}
                    <div
                        style={{
                            borderRadius: '0 0 8px 8px',
                            padding: '20px',
                            border: '1px solid #e0e0e0',
                            borderTop: 'none',
                        }}
                    >
                        {productosAgregados.length === 0 ? (
                            <div
                                className="text-center py-5"
                                style={{
                                    background: 'white',
                                    borderRadius: '8px',
                                    border: '2px dashed #d0d0d0',
                                }}
                            >
                                <FaShoppingCart size={50} color="#d0d0d0" className="mb-3" />
                                <h6 className="text-muted mb-1">No hay productos agregados</h6>
                                <p className="text-muted small mb-0">Haz clic en "Agregar Producto" para comenzar</p>
                            </div>
                        ) : (
                            <>
                                {/* Lista de productos */}
                                <div
                                    style={{
                                        maxHeight: "500px",
                                        overflowY: "auto",
                                        paddingRight: '8px',
                                    }}
                                    className="custom-scrollbar"
                                >
                                    {productosAgregados.map((producto, index) => (
                                        <ProductoCard
                                            key={index}
                                            producto={producto}
                                            index={index}
                                            actualizarCampo={actualizarCampo}
                                            eliminarProducto={eliminarProducto}
                                        />
                                    ))}
                                </div>

                                {/* Resumen de totales profesional */}
                                <div
                                    className="mt-3"
                                    style={{
                                        borderRadius: '8px',
                                        border: '1px solid #e0e0e0',
                                    }}
                                >
                                    <Row className="g-2">
                                        <Col xs={12} md={4}>
                                            <div style={{
                                                padding: '10px',
                                                borderRadius: '6px'
                                            }}>
                                                <p className="mb-1 small " style={{ fontWeight: '500' }}>Subtotal</p>
                                                <h5 className="mb-0" >
                                                    ${subtotal.toFixed(2)}
                                                </h5>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <div style={{
                                                padding: '10px',
                                                borderRadius: '6px'
                                            }}>
                                                <p className="mb-1 small " style={{ fontWeight: '500' }}>IVA</p>
                                                <h5 className="mb-0" >
                                                    ${totalIVA.toFixed(2)}
                                                </h5>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <div style={{
                                                padding: '10px',
                                                borderRadius: '6px',
                                                background: '#009bdb',
                                                border: '1px solid #009bdb',
                                            }}>
                                                <p className="mb-1 small" style={{ color: 'rgba(255,255,255,0.9)', fontWeight: '500' }}>
                                                    Total
                                                </p>
                                                <h4 className="mb-0" style={{ color: 'white', fontWeight: '700' }}>
                                                    ${total.toFixed(2)}
                                                </h4>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </>
                        )}
                    </div>
                </Col>

                {/* Estilos para el scrollbar */}
                <style jsx>{`
                .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #009bdb;
                    border-radius: 4px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #007a9e;
                }
            `}</style>

                {
                    mostrarModal &&
                    <>
                        <ModalProductos
                            mostrarModal={mostrarModal}
                            setMostrarModal={setMostrarModal}
                            ObtenerProductoPorID={ObtenerProductoPorID}
                            agregarProducto={agregarProducto}
                            productosAgregados={productosAgregados}
                        />
                    </>

                }

            </Row>
        </>
    );
};


ProductosContainer.propTypes = {
    productosAgregados: PropTypes.array,
    ordenDetallesProductos: PropTypes.array,
    setProductosAgregados: PropTypes.func,
    setCargando: PropTypes.func
};

export default ProductosContainer;
